import React from 'react';
import ContactUs from './ContactUs';
import Navbar from '../HomePage/Navbar';
// import Footer from '../HomePage/Footer';

function ContactUsIndex() {
  return (
    <div style={{ fontFamily: 'Poppins, sans-serif' }}>
      <Navbar />
      <ContactUs />
      {/* <Footer /> */}
    </div>
  );
}

export default ContactUsIndex;
